$(document).ready(function(){
$('.brand-review-slider-wrapper').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow:1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});
$(document).ready(function() {
    $("a.read-more-reviews-mobile-only").on("click", function(event) {
        event.preventDefault();
        var $myDiv = $(".junip-product-review-container");
        if ($myDiv.length) {
            var topPosition = $myDiv.offset().top;
            $('html, body').animate({ scrollTop: topPosition }, 1000); 
        }
    });
});